<template>
  <div class="two-container" >
    <!-- <div class="little-title">{{$theme ? '核心技术' : 'CORE TECHNOLOGY'}}</div> -->
    <div class="little-title2">
      <div>{{ $theme ? "核心技术" : "CORE TECHNOLOGY" }}</div>
    </div>
    <div class="model-two" >
      <!-- :class="{ 'active-list': activeList == item.code }" -->
      <div class="con" :class="[activeList == 2 ? 'show-right' : 'show-left']">
        <div class="list-item" v-for="(item, ind) in technologyList" :key="ind">
          <div class="img-con">
            <img class="img img1" :src="item.img" alt="" />
            <!-- <img class="img img2" :src="item.img" alt="" /> -->
          </div>
          <div class="desc">{{ $theme ? item.desc : item.enDesc }}</div>
          <div class="name">{{ $theme ? item.name : item.enName }}</div>
        </div>
      </div>
    </div>
    <div class="quan" v-if="activeList==1" @click="activeList=2">
          <div class="con">
            <i class="el-icon-right"></i>
            <i class="el-icon-right"></i>
          </div>
        </div>
        <div class="quan quan2" v-if="activeList==2" @click="activeList=1"> 
          <div class="con">
            <i class="el-icon-right"></i>
            <i class="el-icon-right"></i>
          </div>
        </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      technologyList: [
        {
          name: "边缘计算物联网SIP",
          enName: "Edge Computing IoT SIP",
          enDesc:
            "With dual-core architecture, strong security and edge computing support, it ADAPTS to various IoT application scenarios and provides high-performance, low-latency and secure communication solutions",
          code: 1,
          img: require("/static/image/home/bg-new-1.png"),
          desc: "凭借双核架构、强大的安全性和边缘计算支持，适配各类物联网应用场景，提供高性能、低延迟和安全的通信解决方案",
        },
        {
          name: "多模异构无线承载物联网络",
          enName: "Multimode Heterogeneous Wireless Hosting IoT Networks",
          enDesc:
            "Professional wireless network bearer services that provide access to massive heterogeneous IoT devices and support on-demand link allocation and link self-healing",
          code: 2,
          img: require("/static/image/home/bg-new-2.png"),
          desc: "提供海量异构物联设备接入，支持链路按需分配和链路自愈的专业无线网络承载服务",
        },
        {
          name: "湖仓一体数据智能融合分析",
          enName: "Lake Warehouse Integrated Data Intelligent Fusion Analysis",
          enDesc:
            'It adopts the open architecture of "Lake warehouse in one" to achieve a unified data management platform of technology integration, data integration and business integration across departments, regions and levels',
          code: 3,
          img: require("/static/image/home/bg-new-3.png"),
          desc: "采用'湖仓一体'的开放架构，实现跨部门、跨地区、跨层级的技术融合、数据融合、业务融合的统一数据管理平台",
        },
        {
          name: "一站式算法配置赋能",
          enName: "One-stop Algorithm Configuration Enabling",
          enDesc:
            "One-stop algorithm reasoning deployment capability, providing a large number of mature algorithms to easily enable enterprise AI transformation and upgrading",
          code: 4,
          img: require("/static/image/home/bg-new-4.png"),
          desc: "一站式算法推理部署能力，提供海量成熟算法轻松赋能企业AI转型升级",
        },
        {
          name: "融合CIM可视化的应急指挥调度",
          enName: "Integrated CIM Visual Emergency Command and Scheduling",
          enDesc:
            "With CIM as the visualization base, it integrates functions such as Internet of Things device access, streaming media video borrowing, and cluster voice intercom to achieve the command and scheduling capabilities of full network integration, full domain coverage, communication accessibility, and command visibility",
          code: 5,
          img: require("/static/image/home/bg-new-5.png"),
          desc: "以CIM为可视化底座，融合物联设备接入、流媒体视频借阅和集群语音对讲等功能，实现全网融合、全域覆盖、通信可达、指挥可视的指挥调度能力",
        },
      ],
      activeList: 1,
      scal: 1,
    };
  },
  props: {},
  components: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {
    var element = document.body.clientWidth;
    this.scal = element/1920
  },
  watch: {},
};
</script>

<style scoped lang="scss">
@import "./Index.scss";
</style>
